const StateStatus = {
  ERROR: 0,
  NOT_INITIALIZED: 1,
  LOADING: 2,
  LOADED: 3,
  REFRESHING: 4
};
export { StateStatus };